module.exports = __webpack_public_path__ + "img/co2.6bbe1ae6.png";